import cslx from 'clsx';

export enum InvoiceStatuses {
  PAID = 'PAID',
  UNPAID = 'UNPAID',
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  AUTHORIZED = 'AUTHORIZED',
  SHIPPING = 'SHIPPING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
}

interface InvoiceStatusProps {
  status: keyof typeof InvoiceStatuses;
  t: any;
}

type StatusProps = {
  [key in InvoiceStatuses]: {
    styles: string;
    percent: number;
    progressBg: string;
  };
};

const defaultStyles = 'rounded-8-0 py-1-0 px-1-6 shadow-lg';

const propsByStatus: StatusProps = {
  [InvoiceStatuses.PAID]: {
    styles: 'bg-secondary-green text-primary-green',
    progressBg: 'bg-[#33BA27]',
    percent: 100,
  },
  [InvoiceStatuses.SHIPPING]: {
    styles: 'bg-secondary-green text-primary-green',
    progressBg: 'bg-[#33BA27]',
    percent: 100,
  },
  [InvoiceStatuses.COMPLETED]: {
    styles: 'bg-secondary-green text-primary-green',
    progressBg: 'bg-[#33BA27]',
    percent: 100,
  },
  //
  [InvoiceStatuses.CREATED]: {
    styles: 'bg-primary-yellow text-primary-dark',
    progressBg: 'bg-primary-yellow',
    percent: 50,
  },
  [InvoiceStatuses.PENDING]: {
    styles: 'bg-primary-yellow text-primary-dark',
    progressBg: 'bg-primary-yellow',
    percent: 50,
  },
  [InvoiceStatuses.AUTHORIZED]: {
    styles: 'bg-primary-yellow text-primary-dark',
    progressBg: 'bg-primary-yellow',
    percent: 50,
  },
  [InvoiceStatuses.UNPAID]: {
    styles: 'bg-secondary-grey text-primary-dark',
    progressBg: '',
    percent: 0,
  },
  [InvoiceStatuses.CANCELLED]: {
    styles: 'bg-secondary-grey text-primary-dark',
    progressBg: '',
    percent: 0,
  },
  [InvoiceStatuses.EXPIRED]: {
    styles: 'bg-secondary-grey text-primary-dark',
    progressBg: '',
    percent: 0,
  },
};

const InvoiceStatus: React.FC<InvoiceStatusProps> = (props) => {
  const { status = InvoiceStatuses.CREATED, t } = props;

  return (
    <div className={cslx(propsByStatus[status].styles, defaultStyles)}>
      <p className="font-bd">
        {t(`customer.invoices.${status.toLowerCase()}`)}
      </p>
    </div>
  );
};

export default InvoiceStatus;
